export const common = {
  actions: {
    actions: '操作',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    view: '查看',
    detail: '详情',
    list: '列表',
    show: '显示',
    update: '更新',
    duplicate: '复制',
    download: '下载',
    downloadTemplate: '下载模板',
    downloadErrorFile: '下载错误文件',
    upload: '上传',
    print: '打印',
    close: '关闭',
    open: '打开',
    add: '添加',
    remove: '移除',
    select: '选择',
    clear: '清除',
    submit: '提交',
    reset: '重置',
    confirmDelete: '确认删除',
    confirmAction: '确认操作',
    approve: '批准',
    reject: '拒绝',
    archive: '归档',
    unarchive: '取消归档',
    activate: '激活',
    deactivate: '非激活',
    stopActivity: '停用',
    allowActivity: '允许启用',
    enable: '启用',
    disable: '禁用',
    lock: '锁定',
    unlock: '解锁',
    importData: '导入数据',
    exportData: '导出数据',
    generateReport: '生成报告',
    viewReport: '查看报告',
    send: '发送',
    receive: '接收',
    process: '处理',
    validate: '验证',
    complete: '完成',
    cancelAction: '取消操作',
    create: '创建',
    back: '返回',
    skip: '跳过',
    next: '下一步',
    previous: '上一步',
    confirm: '确认',
    apply: '应用',
    search: '搜索',
    selectNone: '不选择',
    filter: '过滤',
    export: '导出',
    import: '导入',
    stop: '停止',
    previewBeforeCreate: '创建前预览',
    refresh: '刷新',
    imagePreview: '查看图片',
    hideFilter: '隐藏筛选',
    showFilter: '显示筛选',
    comingSoon: '功能开发中',
  },
  status: {
    active: '激活',
    inactive: '非激活',
    listActive: '启用',
    listInactive: '停用',
    pending: '待处理',
    completed: '已完成',
    cancelled: '已取消',
    draft: '草稿',
  },
  messages: {
    success: '成功',
    updateSuccess: '更新成功',
    createSuccess: '创建成功',
    deleteSuccess: '删除成功',
    error: '发生错误',
    warning: '警告',
    info: '信息',
    loading: '加载中...',
    noData: '没有可用数据',
    confirmDelete: '您确定要删除此项吗？',
    confirmDeleteCode: '将删除：{code}',
    noImages: '没有可用的图片',
    checkRequiredFields: '请检查必填字段',
    'image/*': '只允许图像文件',
    cantUploadImage: '无法上传图像',
    uploadImageError: '上传图像时出错',
    uploading: '正在上传图像...',
    pasteNoImage: '剪贴板没有图像。请复制图像或粘贴 http(s) 链接。',
    uploadSuccess: '图像上传成功',
    uploadMore: '上传更多图像',
    dragHere: '拖动并将图像放在这里',
    orClickHere: '或单击此处选择',
    dragHereOrClick: '拖动并将图像放在这里或单击选择',
  },
  validation: {
    required: '此字段是必填的',
    email: '无效的电子邮件格式',
    minLength: '最少 {min} 个字符',
    maxLength: '最多 {max} 个字符',
    numeric: '只允许数字',
  },
  date: {
    today: '今天',
    yesterday: '昨天',
    tomorrow: '明天',
    thisWeek: '本周',
    lastWeek: '上周',
    thisMonth: '本月',
    lastMonth: '上个月',
    thisQuarter: '本季度',
    lastQuarter: '上季度',
    thisYear: '今年',
    lastYear: '去年',
    last7Days: '近7天',
    last30Days: '近30天',
    pickDate: '选择日期',
  },
  sortBy: '排序字段',
  sortDirection: '排序方向',
  asc: '升序',
  desc: '降序',
  table: {
    pageSize: '每页条数',
    perPage: '页',
    showingRange: '显示 {from} - {to} / 共 {total} 条',
    showingRangeProducts: '显示 {from} - {to} / 共 {total} 个产品',
    rowActions: '操作',
  },
  labels: {
    code: '编码',
  },
  account: '账户',
  profile: '个人资料',
  role: {
    super_admin: '超级管理员',
    admin: '管理员',
    manager: '经理',
    standard_user: '员工',
    customer: '客户',
  },
  total: '总计',
  yes: '是',
  no: '否',
  stt: '序号',
  noData: '暂无数据',
  getTax: '取税',
  themeAccent: {
    aria: '选择主题色',
  },
  importModal: {
    fileSelected: '已选文件：{name}',
  },
  importTemplate: {
    success: '模板下载成功',
    failed: '模板下载失败',
  },
  importResult: {
    errorColumnHeader: '错误',
    downloadErrorFileFailed: '无法创建错误文件',
  },
  import: {
    stubDescription: '按模板选择 Excel 文件。数据通过临时导入 API 提交，正式接口就绪后可替换。',
    stubSuccess: '导入成功（临时 API）。',
    stubFailed: '导入失败。',
    noData: '文件中没有有效数据行。',
    noSheet: 'Excel 文件没有数据工作表。',
    notSupportedByBackend: '后端尚未支持此模块的 Excel 导入。',
  },
  export: {
    exportFile: '导出',
    exportExcelButton: '导出 Excel',
    exportOverview: '导出总览',
    exportDetail: '导出明细',
    exportSuccess: '已下载 Excel 文件。',
    selectRowForDetail: '请先在表格中选择一行以导出明细。',
    selectRowsFirst: '请至少勾选一行再导出。',
    exportSelectedVisible: '已选 — 当前显示列 ({count})',
    exportSelectedAllColumns: '已选 — 全部列 ({count})',
    exportSelectedWithLinesVisible: '已选 + 明细 — 当前显示列 ({count})',
    exportSelectedWithLinesAll: '已选 + 明细 — 全部列 ({count})',
    exportFilterVisible: '按筛选 — 当前显示列',
    exportFilterAllColumns: '按筛选 — 全部列',
    exportFilterWithLinesVisible: '按筛选 + 明细 — 当前显示列',
    exportFilterWithLinesAll: '按筛选 + 明细 — 全部列',
    lineCode: '商品编码',
    lineName: '商品名称',
    lineQty: '数量',
    linePrice: '单价',
    lineAmount: '金额',
    lineUnit: '单位',
    lineDiscount: '行折扣',
    lineSellPrice: '售价',
    lineSharedDiscount: '整单折扣',
    lineOtherFee: '其他费用',
    lineTotal: '合计',
    lineWeight: '重量 (kg)',
    lineVolume: '体积 (m³)',
    lineNote: '备注',
    customerCode: '客户编码',
    customerName: '客户名称',
    branch: '门店',
    seller: '销售员',
    time: '时间',
    status: '状态',
    infoSheet: '单据信息',
    listSheet: '发票列表',
    linesSheet: '商品明细',
    infoField: '字段',
    infoValue: '值',
  },
  /** 通用 `ConfirmDialog`（BaseModal）文案 — 任意模块复用。 */
  confirmDialog: {
    /** 代码数量 > maxInlineCodes 时："... 以及其他 {count} 个" */
    bulkAndMore: '... 以及其他 {count} 个',
  },
  /** 销售页标签页通用文案（右键菜单 + 批量关闭）。 */
  unsaved: {
    closeTitle: '关闭未保存的单据？',
    closeBody: '输入的数据尚未保存，关闭将丢失这些修改。',
    discard: '关闭并放弃',
  },
  tabs: {
    closeTab: '关闭标签页',
    closeOthers: '关闭其他标签页',
    closeRight: '关闭右侧标签页',
    bulkCloseTitle: '关闭多个标签页？',
    bulkCloseBody: '有 {count} 个标签页存在未保存的更改，关闭后将丢失这些更改。',
    closeAllDrafts: '关闭所有草稿',
    closeAllDraftsTitle: '关闭所有草稿？',
    closeAllDraftsBody: '将删除全部 {count} 个已打开的草稿，未保存的数据将丢失，随后打开一个新的空白单据。',
  },
  /** 列表侧边栏共用的分店筛选文案。 */
  filter: {
    chiNhanh: '分店',
    chiNhanhAll: '全部分店',
    chiNhanhSearch: '搜索分店',
    chiNhanhEmpty: '暂无分店',
    chonTatCa: '全选',
    boChonTatCa: '取消全选',
  },
  /** 列表显隐列菜单（ProductListColumnMenu — 各模块共用）。 */
  columnPicker: {
    selectAll: '全选',
    deselect: '取消选择',
    default: '默认',
    sort: '排序',
    sortDone: '完成排序',
    resetOrder: '重置顺序',
    sortHint: '勾选要移动的列，再在其他列上按 ↑/↓ 放到上方/下方',
    fixedLeft: '固定左侧',
    fixedRight: '固定右侧',
    columnsTitle: '列',
    sortColumnsTitle: '排序列',
    placeAbove: '放到上方',
    placeBelow: '放到下方',
    autoFit: '自动适应列宽',
    viewMenu: '显示',
    defaultView: '默认',
    defaultViewHint: '常规样式，原始列宽',
    autoFitShort: '适应列宽',
    excelView: 'Excel',
    excelViewHint: '网格线，紧凑单元格',
    ultraView: '超紧凑',
    ultraViewHint: '网格线、小字号、紧凑单元格 — 显示最多行',
    resizeHandle: '拖动调整列宽，双击适应内容',
    resetWidths: '默认',
    resetWidthsHint: '恢复默认列宽（清除本设备上的调整）',
    gridLines: '网格',
    gridLinesHint: '显示/隐藏列之间的分隔线',
    actionsColumn: '列 {name}',
    decreaseFixed: '减少固定列数',
    increaseFixed: '增加固定列数',
  },
  voucherPrint: {
    title: '打印单据',
    codeLabel: '单据编号',
    templateLabel: '打印模板',
    printButton: '打印',
    exportExcelButton: '导出 Excel',
    editTemplateButton: '编辑打印模板',
    loading: '正在加载打印数据…',
    loadingPreview: '正在加载预览…',
    loadError: '无法加载打印数据',
    printError: '无法打印单据',
    missingId: '缺少单据 ID',
    batchCount: '{count} 张单据',
    batchModeOnce: '一次打印',
    batchModeOnceHint: '一个打印对话框 — 每张发票另起一页，不共用页',
    batchModeEach: '每单一次',
    batchModeEachHint: '每张发票单独打开打印对话框',
    noTemplate: '暂无模板',
    noTemplateHint: '此单据类型尚无模板 — 点击打印时将使用默认模板。',
    defaultBadge: '默认',
    previewButton: '试打印',
    previewTitle: '试打印',
    previewDraftBadge: '草稿 — 未保存',
    previewEmpty: '暂无可试打印的数据',
    pdfGroup: 'PDF 模板',
    excelGroup: 'Excel 模板',
    builtInTemplate: '内置模板',
    printSelected: '打印 ({count})',
    exportSelected: '导出 Excel ({count})',
    selectAll: '全选',
    previewPane: '预览',
    templatesPane: '模板',
    paperSize: '{w} × {h} mm',
    zoomOut: '缩小',
    zoomIn: '放大',
    zoomReset: '100%',
  },
  voucherQr: {
    column: '二维码',
    view: '查看二维码',
    title: '单据二维码',
    copyCode: '复制编号',
    copied: '已复制单据编号',
    copyError: '复制失败',
    download: '下载二维码',
    linkedCodes: '关联单号',
  },
  disabledReason: {
    processing: '正在处理，请稍候…',
    noCode: '单据尚无编号，无法生成二维码',
    notSaved: '单据尚未保存',
    printUnavailable: '此类单据尚未配置打印模板',
  },
  filePreview: {
    title: '文件预览',
    kindPdf: 'PDF',
    kindExcel: 'Excel',
    kindImage: '图片',
    kindOther: '文件',
    prev: '上一个',
    next: '下一个',
    prevFile: '上一个文件',
    nextFile: '下一个文件',
    openOriginal: '打开原链接',
    openFile: '打开文件',
    missingUrl: '缺少可预览的文件链接。',
    excelNoSheet: '该 Excel 文件没有数据工作表。',
    excelRowLimit: '仅预览前 {n} 行 — 下载文件查看完整内容。',
    unsupported: '该格式暂不支持在浏览器中预览，请打开原链接或下载。',
  },
  entityCode: {
    detailTitle: '{name}详情',
    detailTitleWithCode: '{name}详情 — {code}',
    types: {
      hoaDon: '发票',
      traHang: '退货单',
      datHang: '订单',
      phieuXuatKho: '出库单',
      phieuNhapKho: '入库单',
      chuyenHang: '调拨单',
      kiemKe: '盘点单',
      yeuCauSuaChua: '维修申请',
      yeuCauXuatHoaDon: '开票申请',
      datHangNcc: '采购订单',
      phieuNhanHang: '收货单',
      khachHang: '客户',
      product: '商品',
    },
  },
}
